import { Box, Flex, Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { FaCircleCheck } from "react-icons/fa6"
import { useHistory } from "react-router-dom"
import { Routes } from "src/constants"
import { SDKContext } from "src/context/SDKContext"
import { PlansPageStyling } from "src/context/types"
import { useBrowserType } from "src/hooks/useBrowserType"
import usePageStyling from "src/hooks/usePageStyling"
import useWindowSize from "src/hooks/useWindowSize"
import axios from "src/shared/axios"
import { PlansButton } from "./PlansButton"
import { PlansData } from "./PlansData"
import { StripeSubscriptionPlans } from "./StripeSubscriptionPlans"

export const StripeSubscription: React.FC<{
  hasCancelled: boolean
  plansData: PlansData
  cameFromCheckoutSuccess: boolean
  setHasCancelled: React.Dispatch<React.SetStateAction<boolean>>
  fetchPlansData: () => Promise<void>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}> = ({
  hasCancelled,
  plansData,
  cameFromCheckoutSuccess,
  setHasCancelled,
  fetchPlansData,
  setLoading
}) => {
  const { t } = useTranslation()
  const { screenSize } = useWindowSize()
  const { isSafariMobile, isAndroid } = useBrowserType()
  const isMobile = isSafariMobile || isAndroid
  const isLandscape = screenSize.width > screenSize.height
  const meetingClient = React.useContext(SDKContext)
  const plansPageStyles: PlansPageStyling = usePageStyling("plansPageStyling")
  const history = useHistory()

  const cancelledSubscription =
    hasCancelled ||
    (plansData.unsubscribeDetectedAt != null && hasCancelled === null)

  if (cancelledSubscription) {
    return (
      <>
        <Text
          color={plansPageStyles?.planPagePanelSubTextColor}
          textAlign={"center"}
        >
          You have cancelled your subscription.
          {plansData.unsubscribeDetectedAt != null && (
            <>
              <br />
              It will end on{" "}
              {new Date(plansData.unsubscribeDetectedAt).toDateString()}
            </>
          )}
        </Text>
        {/* {!cameFromCheckoutSuccess && (
          <StripeSubscriptionPlans
            fetchPlansData={fetchPlansData}
            plansData={plansData}
          />
        )} */}
      </>
    )
  }

  return (
    <>
      {!cameFromCheckoutSuccess ? (
        <Text
          color={plansPageStyles?.planPagePanelSubTextColor}
          textAlign={"center"}
        >
          Your subscription will renew on{" "}
          {new Date(plansData.expiresDate).toDateString()}
        </Text>
      ) : (
        <Flex direction={"column"} alignItems={"center"}>
          <Box background={"white"} borderRadius="9999px">
            <Box margin="-2px">
              <FaCircleCheck size="60px" color="green" />
            </Box>
          </Box>
          <Text
            color={plansPageStyles?.planPagePanelSubTextColor}
            textAlign={"center"}
            paddingTop="10px"
          >
            Your subscription purchase was successful
          </Text>
          <PlansButton
            isMobile={isMobile}
            isLandscape={isLandscape}
            onClick={() => {
              localStorage.setItem("avatarsTabIndex", JSON.stringify(0))
              history.replace(Routes.AVATARS)
            }}
          >
            {t("Explore")}
          </PlansButton>
        </Flex>
      )}
      {/* {!cameFromCheckoutSuccess && (
        <StripeSubscriptionPlans
          fetchPlansData={fetchPlansData}
          plansData={plansData}
        />
      )} */}
    </>
  )
}
